module.exports = __webpack_public_path__ + "static/img/bctps.6d15790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/bctps.png
// module id = nzol
// module chunks = 1